import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IGoalTable, IAuthReduxProps, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from '../tables_manager/EditableCell';
import { addOrEditSpecificGoal } from '../../flux/actions/goalActions';
import { addOrEditSpecificBudget } from '../../flux/actions/budgetActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faCommentDots, faEdit, faExclamationTriangle, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const GoalTable = ({ 
  linesData,
  societeValue,
  goals,
  goal_societe_defaults,
  budgets,
  showUsers,
  setShowUsers,
  societeId,
  addOrEditSpecificGoal,
  addOrEditSpecificBudget,
  auth
 }: IGoalTable) => {
  const [isUpdating, setIsUpdating] = useState(false)

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "name",
        className: "tableLeftHeader text-left",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value, row: {original} }) => <div style={{...(!!original?.isUser && {fontWeight: "normal", textDecoration: "underline"})}}>{value}{!!original.showHideUsers && <>&nbsp;<FontAwesomeIcon icon={showUsers ? faEyeSlash : faEye} /*className={`flipIcon${showUsers ? " flipped" : ""}`}*/ style={{cursor: "pointer"}} onClick={() => setShowUsers(e => !e)} title="Afficher/Masquer les objectifs des commerciaux" /></>}</div>
      },
      ...([
          {title: "Objectifs Ventes", accessor: "goalV"},
          {title: "Objectifs Encaissements Ventes", accessor: "goalE"},
          {title: "Objectifs Recouvrement", accessor: "goalR"},
          {title: "Objectifs Livraison", accessor: "goalL"}
        ].map(e => ({
        Header: e.title,
        accessor: e.accessor,
        disableFilters: true,
        Cell: (e) => e.row.original.isBudget || e.row.original.isUser ? EditableCell({...e, isDouble: true, isPrice: true, ignoreMaximumLimit: true, customeUpdateCallback: editBudget, disabled: isUpdating}) : `${Number(e.value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH`
      }))),
    ],
    [showUsers, isUpdating]
  );

  const editBudget = (original, column, value) => {
    setIsUpdating(true)
    // setTimeout(() => setIsUpdating(false), 700)
    if(original.isUser)
      addOrEditSpecificGoal(original.month, original.year, original.user?.id || -1, societeId || -1, column, Number(value || 0), auth?.user?.id, () => setIsUpdating(false))
    else if(original.isBudget)
      addOrEditSpecificBudget(original.month, original.year, societeId || -1, column, Number(value || 0), auth?.user?.id, () => setIsUpdating(false))
  }

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} showPagination={false} enableCheckBox={false} isEditable={false} centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {addOrEditSpecificGoal, addOrEditSpecificBudget})(GoalTable);
